export const SET_AUTH_USER = 'SET_AUTH_USER';

export const setAuthUser = user => ({
  type: SET_AUTH_USER,
  user,
});
